import {Card, theme, Typography} from 'antd';
import React from 'react';

interface IProps {
  item: any;
  toggleView?: any;
  handleItem?: any;
}

const GMGiftCard: React.FC<IProps> = (props) => {
  const {item, toggleView, handleItem} = props;
  const {token}: any = theme.useToken();
  const toggleAndHandle = () => {
    toggleView();
    handleItem(item);
  };

  return (
    <Card
      hoverable
      onClick={toggleAndHandle}
      style={{flex: '0 0 23%', borderColor: token.colorBorderSecondary}}
      styles={{
        body: {display: 'flex', flexDirection: 'column', gap: 16, width: '100%', padding: 0},
      }}
      cover={
        <img
          src={item.images[1].imageUrl}
          alt={item.images[1].altText}
          style={{height: 140, objectFit: 'cover'}}
        />
      }>
      <Typography.Text
        style={{
          display: 'block',
          backgroundColor: token.colorTextBase,
          color: token.colorBgContainer,
          textAlign: 'center',
          width: '100%',
          padding: '4px 0',
        }}>
        {item?.redemptionDetails[0].method === 'PHYSICAL' ? 'Plastic' : 'eGift'}
      </Typography.Text>
      <div style={{padding: '0 16px 16px'}}>
        <Typography.Text style={{textAlign: 'center', alignSelf: 'center'}}>
          {item.titleShort}
        </Typography.Text>
      </div>
    </Card>
  );
};

export default GMGiftCard;
